import { combineAll } from "rxjs/operators";
import { Combo } from "../models/combo";
import { MenuItemHolder } from "./menu-item-holder";

export class ComboHolder 
{
    public Combo:Combo = new Combo;
    public ComboItemHolders:Array<MenuItemHolder> = [];

    public get Name()
    {
        var name = this.Combo.Name;

        if(name.length > 25)
            return name.substring(0, 25) + '...';

        return name;
    }

    public get CurrentPrice()
    {
        var currentPrice = this.Combo.DefaultPrice;

        for (let index = 0; index < this.ComboItemHolders.length; index++) 
        {
            const itemHolder = this.ComboItemHolders[index];
            
            currentPrice += itemHolder.CurrentComboPrice;
        }

        return currentPrice * this.Combo.ComboCount;
    }

    public get ID()
    {
        return this.Combo.ID;
    }

    public get UniversalID()
    {
        return this.Combo.UniversalID;
    }

    public get CountName()
    {
        return `${this.Combo.ComboCount} ${this.Combo.Name}`;
    }

    public get Summary()
    {
        var text = "";

        for (let index = 0; index < this.ComboItemHolders.length; index++) 
        {
            const itemHolder = this.ComboItemHolders[index];

            text += `*${itemHolder.CountName}*\n${itemHolder.Summary}\n${this.ComboItemHolders.length - 1 === index ? "" : "\n\n"}`;
        }
        
        return text;
    }

    public get Tags()
    {
        var tags = new Array<string>();

        if(this.Combo.Tags !== undefined)
        {
            for (let index = 0; index < this.Combo.Tags.length; index++) 
            {
                const tag = this.Combo.Tags[index];
                
                tags.push(tag);
            }
        }

        for (let index = 0; index < this.ComboItemHolders.length; index++) 
        {
            const itemHolder = this.ComboItemHolders[index];
            
            for (let index = 0; index < itemHolder.Tags.length; index++) 
            {
                const tag = itemHolder.Tags[index];

                tags.push(tag);
            }
        }

        return tags;
    }

    public getValidation()
    {
        return this.Combo.ItemGroupsList.every(x => x.CurrentItem.length > 0 || x.IsEmpty) && this.ComboItemHolders.every(holder => holder.getValidation() === true);
    }
}
